import React from 'react';
import { Grid, MenuItem } from '@mui/material';
import SelectFieldContext from 'components/CustomInputsInFormikContext/Select';
import TextFieldContext from 'components/CustomInputsInFormikContext/TextField';
import CardWrapper from 'components/Financial/CardWrapper';
import { useFormikContext } from 'formik';
import { isCpf, labelField } from 'utils';
import maskCPF from 'components/Masks/maskCPF';
import maskCNPJ from 'components/Masks/maskCNPJ';

function Identification() {
  const { setFieldValue, getFieldMeta } = useFormikContext();
  const { value: nature } = getFieldMeta('nature');

  const cpfSelected = isCpf(nature);

  return (
    <CardWrapper title="Identificação">
      <Grid item xs={12} sm={6} md={4}>
        <TextFieldContext
          name="name"
          label={labelField('Nome')}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <SelectFieldContext
          id="nature"
          name="nature"
          label={labelField('Natureza')}
          onChangeCallback={() => {
            setFieldValue('cpfCnpj', '');
          }}
        >
          <MenuItem key={1} value="Pessoa Física">
            Pessoa Física
          </MenuItem>
          <MenuItem key={2} value="Pessoa Jurídica">
            Pessoa Jurídica
          </MenuItem>
        </SelectFieldContext>
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <TextFieldContext
          InputProps={{
            inputComponent: cpfSelected ? maskCPF : maskCNPJ,
          }}
          id="cpfCnpj"
          label={cpfSelected ? labelField('CPF') : labelField('CNPJ')}
          name="cpfCnpj"
        />
      </Grid>
    </CardWrapper>
  );
}

export default Identification;
